/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { CONFIG } from '../../core/config';
import { Industry } from '../industry';
import { IndustryHierarchy } from '../industry-hierarchy/industry-hierarchy';
import { EquipmentClassSelection, IndustryHierarchySelection } from '../model';
import { ViewModel } from '../view-model';
import { EquipmentClass } from './equipment-class';
import { EquipmentClassType } from './equipment-class-type';
import { EquipmentComponent } from './equipment-component';
import { EquipmentPart } from './equipment-part';
import { EquipmentSubUnit } from './equipment-sub-unit';

export abstract class EquipmentFunctionModelSelectionCriteriaBase implements ViewModel, IndustryHierarchySelection, EquipmentClassSelection {
  public static readonly unfoundModelName = 'None';

  abstract friendlyTypeNameSingular: string;
  abstract apiRoute: string;

  equipmentLibraryId: string = CONFIG.constants.noneDropdownValue;

  industry: Industry = new Industry();
  industryHierarchyItem: IndustryHierarchy = new IndustryHierarchy();

  equipmentClassId: string;
  equipmentClassItem: EquipmentClass = new EquipmentClass();
  equipmentClassTypeId: string;
  equipmentClassType: EquipmentClassType = new EquipmentClassType();
  equipmentSubUnitId: string;
  equipmentSubUnitItem: EquipmentSubUnit = new EquipmentSubUnit();
  equipmentComponentId: string;
  equipmentComponentItem: EquipmentComponent = new EquipmentComponent();
  equipmentPartId: string;
  equipmentPartItem: EquipmentPart = new EquipmentPart();
  excludedModelIds: string[] = [];
  requiresFunctions: boolean;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.equipmentLibraryId = data.equipmentLibraryId;

    if (data.industry) {
      this.industry = new Industry();
      this.industry.industryId = data.industry.industryId;
      this.industry.industryName = data.industry.industryName;
    }

    if (data.industryHierarchyItem) {
      this.industryHierarchyItem = new IndustryHierarchy();
      this.industryHierarchyItem.loadFromJson(data.industryHierarchyItem);
    }

    if (data.equipmentClassItem) {
      this.equipmentClassItem = new EquipmentClass();
      this.equipmentClassItem.loadFromJson(data.equipmentClassItem);
    }

    if (data.equipmentClassType) {
      this.equipmentClassType = new EquipmentClassType();
      this.equipmentClassType.loadFromJson(data.equipmentClassType);
    }

    if (data.equipmentSubUnitItem) {
      this.equipmentSubUnitItem = new EquipmentSubUnit();
      this.equipmentSubUnitItem.loadFromJson(data.equipmentSubUnitItem);
    }

    if (data.equipmentComponentItem) {
      this.equipmentComponentItem = new EquipmentComponent();
      this.equipmentComponentItem.loadFromJson(data.equipmentComponentItem);
    }

    if (data.equipmentPartItem) {
      this.equipmentPartItem = new EquipmentPart();
      this.equipmentPartItem.loadFromJson(data.equipmentPartItem);
    }

    this.equipmentClassId = data.equipmentClassId;
    this.equipmentClassTypeId = data.equipmentClassTypeId;
    this.equipmentSubUnitId = data.equipmentSubUnitId;
    this.equipmentComponentId = data.equipmentComponentId;
    this.equipmentPartId = data.equipmentPartId;

    if (data.excludedModelIds) {
      this.excludedModelIds = data.excludedModelIds.slice();
    }

    this.requiresFunctions = data.requiresFunctions;
  }

  abstract hasModel(): boolean;
  abstract modelName(): string;
}
